// deviceDetector.js

/**
 * 检测设备环境信息
 * @returns {Object} 设备信息对象
 *
 * 返回对象包含:
 *   isMobile: 是否为移动设备 (Boolean)
 *   deviceType: 设备类型 ('mobile', 'tablet', 'desktop')
 *   os: 操作系统 ('iOS', 'Android', 'Windows', 'macOS', 'Linux', 'Unknown')
 *   browser: 浏览器类型 ('Chrome', 'Firefox', 'Safari', 'Edge', 'Opera', 'IE', 'Unknown')
 *   isWeChat: 是否在微信浏览器中 (Boolean)
 *   userAgent: 原始User Agent字符串
 */
export const detectDevice = () => {
  // 处理服务端渲染(SSR)情况
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      deviceType: "desktop",
      os: "Unknown",
      browser: "Unknown",
      isWeChat: false,
      userAgent: "Server"
    };
  }

  const ua = navigator.userAgent;

  // 初始化结果对象
  const result = {
    isMobile: false,
    deviceType: "desktop",
    os: "Unknown",
    browser: "Unknown",
    isWeChat: /MicroMessenger/i.test(ua),
    userAgent: ua
  };

  try {
    // 操作系统检测
    if (/android/i.test(ua)) {
      result.os = "Android";
      result.isMobile = true;
    } else if (/ipad|ipod|iphone/i.test(ua)) {
      result.os = "iOS";
      result.isMobile = true;
    } else if (/win/i.test(ua)) {
      result.os = "Windows";
    } else if (/mac/i.test(ua)) {
      result.os = "macOS";
    } else if (/linux/i.test(ua)) {
      result.os = "Linux";
    }

    // 浏览器检测
    if (/edg/i.test(ua)) {
      result.browser = "Edge";
    } else if (/opr/i.test(ua)) {
      result.browser = "Opera";
    } else if (/chrome/i.test(ua) && !/edg/i.test(ua)) {
      result.browser = "Chrome";
    } else if (/firefox/i.test(ua)) {
      result.browser = "Firefox";
    } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
      result.browser = "Safari";
    } else if (/trident/i.test(ua)) {
      result.browser = "IE";
    }

    // 设备类型检测
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(ua)) {
      result.deviceType = "tablet";
      result.isMobile = true;
    } else if (/mobi|android|iphone|ipod|blackberry|iemobile|opera mini|mobile/i.test(ua)) {
      result.deviceType = "mobile";
      result.isMobile = true;
    } else {
      result.deviceType = "desktop";
    }

    // 平板设备尺寸补充检测 (7-10英寸)
    const screenWidth = window.innerWidth;
    if (!result.isMobile && screenWidth < 1024 && screenWidth >= 768) {
      result.deviceType = "tablet";
      result.isMobile = true;
    }
  } catch (error) {
    console.error("设备检测错误:", error);
    // 出错时默认设为桌面设备
    result.isMobile = false;
    result.deviceType = "desktop";
  }

  return result;
};

/**
 * 判断是否为移动端环境 (H5)
 * @returns {Boolean} 是否为移动设备
 */
export const isMobileDevice = () => {
  return detectDevice().isMobile;
};

/**
 * 判断是否为桌面端环境 (Web)
 * @returns {Boolean} 是否为桌面设备
 */
export const isDesktopDevice = () => {
  return !detectDevice().isMobile;
};
